import { Box, Paper } from '@mui/material';
import { Suspense } from "react";
import { useSelector } from "react-redux";
import DocumentViewer from '../../../../../components/admin/FileOpener/FileViewer';
import LoaderText from '../../../../../components/loader/LoaderText';

const ViewPolicyDocument = () => {
  const { drawerData: uploadDocumentFiles } = useSelector((state: any) => state.drawer);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: "calc(100vh - 59px)" }}>
        <Box sx={{ flexGrow: 1 , textAlign: 'center'}}>
          {uploadDocumentFiles && Array.isArray(uploadDocumentFiles) && uploadDocumentFiles?.length > 0 && (
            <Box sx={{ height: "100%", padding: 2 }}>
              <Suspense fallback={'Loading...'}>
                {uploadDocumentFiles?.map((fileUrl: any, index: number) => (
                  <Box key={index} sx={{ height: "100%" }}>
                    <DocumentViewer filePath={fileUrl?.document_path || fileUrl?.file_path} />
                  </Box>
                )
                )}
              </Suspense>
            </Box>
          )}
          {typeof uploadDocumentFiles == 'string' &&
            <Box sx={{ height: "100%", padding: 2 }}>
              <Suspense fallback={<LoaderText />}>
                <Box key={uploadDocumentFiles} sx={{ height: "100%", display: 'block' }}>
                  <DocumentViewer filePath={uploadDocumentFiles} />
                </Box>
              </Suspense>
            </Box>
          }
        </Box>
      </Paper>
    </Box>
  );
};

export default ViewPolicyDocument;
